import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import FilteredOperationProducers from '@/types/Producer/FilteredOperationProducers';
import Producer from '@/types/Producer/Producer';

export type OperationsProducersState = {
  entries: {
    [agencyName: string]: {
      [operationName: string]: FilteredOperationProducers[];
    };
  };
};

const initialState: OperationsProducersState = {
  entries: {}
};

export const operationsProducersSlice = createSlice({
  name: 'operationsProducers',
  initialState,
  reducers: {
    addAgencyOperationProducers(
      state,
      action: PayloadAction<{
        agencyName: string;
        operationName: string;
        producers: FilteredOperationProducers[];
      }>
    ) {
      const { agencyName, operationName, producers } = action.payload;

      if (!state.entries[agencyName]) {
        state.entries[agencyName] = {};
      }

      state.entries[agencyName][operationName] = producers;
    },

    addAgencyProducerToOperation(
      state,
      action: PayloadAction<{
        agencyName: string;
        operationName: string;
        user: Producer;
      }>
    ) {
      const { agencyName, operationName, user } = action.payload;

      const operationProducers = state.entries[agencyName]?.[operationName];
      if (operationProducers) {
        const index = operationProducers.findIndex(producer => producer.userName === user.userName);

        if (index !== -1) {
          operationProducers[index] = { ...user, isAdded: true };
        }
      }
    },

    deleteAgencyProducerFromOperation(
      state,
      action: PayloadAction<{
        agencyName: string;
        operationName: string;
        userId: string;
      }>
    ) {
      const { agencyName, operationName, userId } = action.payload;

      const operationProducers = state.entries[agencyName]?.[operationName];
      if (operationProducers) {
        const index = operationProducers.findIndex(producer => producer.userName === userId);

        if (index !== -1) {
          operationProducers[index].isAdded = false;
        }
      }
    }
  }
});

export const {
  addAgencyOperationProducers,
  addAgencyProducerToOperation,
  deleteAgencyProducerFromOperation
} = operationsProducersSlice.actions;

export default operationsProducersSlice.reducer;
